import React, { Component } from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../../settings';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Button from '../../../../../components/Button';
import RightSide from '../../../../../components/FormArea/RightSide';
import Loader from '../../../../../components/Loader';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import sortByDate from '../../../../../logic/sortByDate';

class AppearanceOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contracts: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.franchise.contract.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
        FranGuid: this.props.franchiseGuid,
      },
    }).then(contractResponse => {
      const contracts = JSON.parse(contractResponse);
      this.setState({
        contracts,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.contracts.filter(row => row.Guid);

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Verträge'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Guid}`),
              })}
              data={data}
              pageSize={data.length}
              noDataText='Es liegt kein Vertrag für das ausgewählte Büro vor.'
              defaultSorted={[
                {
                  id: 'ContractDate',
                  desc: true,
                },
              ]}
              columns={[
                {
                  Header: 'Vertragsabschluss',
                  accessor: 'ContractDate',
                  sortMethod: sortByDate,
                },
                {
                  Header: 'Gültig ab',
                  accessor: 'From',
                  sortMethod: sortByDate,
                },
                {
                  Header: 'Laufzeit bis',
                  accessor: 'To',
                  sortMethod: sortByDate,
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neuer Vertrag
          </Button>
        </RightSide>
      </>
    );
  }
}

export default AppearanceOverview;
